import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {DISCOUNT_PAYMENT_TYPES, discountInterface, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections, setFinancePaymentType} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import {shouldUseMultipleWorkSheets} from "./discountFunctions";
import {getPriceWithCurrency} from "../../misc/helpers";
import UiIcon from "../ui/icons/uiIcon";
import {getBalanceDueAmount} from "./discountFinanceFunctions";


class DiscountBalanceDue extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount, fabricatorSettings, balanceDueAmount, shoppingCartItem, setFinancePaymentType,
      financePaymentType} = this.props;

    if (shoppingCartItem) {
      return balanceDueAmount
    }

    return (
      <li className={"discount" + (discount.isRequired ? " discount--required" : "")}>
        <div className="discount-cell font--20 bold padding-l-15">{discount.name}</div>
        <div className="discount-cell flex--1 flex flex--center u-gap-1 relative">
          {Object.keys(DISCOUNT_PAYMENT_TYPES).map((key) => {
            const checked = financePaymentType === key;
            const onClick = () => setFinancePaymentType(key);
            return (
              <div key={key}>
                <div className={"ui-checkbox ui-checkbox--normal flex flex--center u-gap-025"
                       // + (cellsAreDisabled || !selectedDiscount ? " ui-checkbox--disabled" : "")
                       + (checked ? " ui-checkbox--checked-svg" : "")}
                     onClick={onClick}>
                  <div className="ui-checkbox__svg">
                    <UiIcon icon="checkmark"/>
                  </div>
                </div>
                <span className="ui-checkbox__label bold" onClick={onClick}>
                  {DISCOUNT_PAYMENT_TYPES[key]}
                </span>
              </div>
            )
          })}
          {discount.isRequired ? (
            <div className={"transition3 z-10 discount-required-triangle absolute u-left-1/2 margin-t-2 u-top-4 " +
              "-translate-x-1/2 -translate-y-1/2 bg-secondary_active bold color-white u-rounded-025 u-pt-05 u-pb-05 u-pr-1 u-pl-1"
              + (financePaymentType || !balanceDueAmount ? " opacity-0 visibility-hidden" : "")}>
              Payment Option Is Required
            </div>
          ) : null}
        </div>
        <div className="discount-cell font--22 bold discount-cell--green padding-r-15">
          {getPriceWithCurrency(fabricatorSettings, balanceDueAmount)}
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store, ownProps) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financePaymentType} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;
  const {showAllQuotesCartItemsList} = store.cartState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financePaymentType,
    balanceDueAmount: getBalanceDueAmount(store, ownProps.discountSection, ownProps.discount, activeQuoteIndex),
    showAllQuotesCartItemsList,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinancePaymentType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountBalanceDue);
